var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoutesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1667 8.25006V13.7501C20.1667 16.0417 19.7083 17.6459 18.6817 18.6817L12.8333 12.8334L19.9192 5.74756C20.0842 6.47173 20.1667 7.29672 20.1667 8.25006Z",
    stroke: "#A19FCB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9192 5.74742L5.74749 19.9191C2.98832 19.2866 1.83333 17.3799 1.83333 13.7499V8.24992C1.83333 3.66659 3.66667 1.83325 8.25 1.83325H13.75C17.38 1.83325 19.2867 2.98826 19.9192 5.74742Z",
    stroke: "#A19FCB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6817 18.6816C17.6458 19.7083 16.0417 20.1666 13.75 20.1666H8.25C7.29667 20.1666 6.47166 20.0841 5.74749 19.9191L12.8333 12.8333L18.6817 18.6816Z",
    stroke: "#A19FCB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.71999 7.31491C6.34332 4.62908 10.3767 4.62908 11 7.31491C11.3575 8.89158 10.3675 10.2299 9.49665 11.0549C8.86415 11.6599 7.865 11.6599 7.22334 11.0549C6.3525 10.2299 5.35332 8.89158 5.71999 7.31491Z",
    stroke: "#A19FCB",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33672 7.97494H8.34495",
    stroke: "#A19FCB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoutesIcon);
export default __webpack_public_path__ + "static/media/routes-icon.bd119fa8682d0f93ace8003fc1dad6cc.svg";
export { ForwardRef as ReactComponent };